import {
  UserCheck, Radar, Timer, Receipt, Globe, Wrench, ArrowRight,
} from "lucide-react";
import { VALUE_ITEMS } from "../data/mock";

const iconMap = {
  UserCheck, Radar, Timer, Receipt, Globe, Wrench,
};

export const WhySection = () => {
  return (
    <section id="why-us" className="py-20 lg:py-28 relative overflow-hidden" style={{ background: 'linear-gradient(160deg, #070e24 0%, #0c1839 30%, #11214d 55%, #0c1839 80%, #070e24 100%)' }}>
      {/* Decorative orbs */}
      <div className="absolute top-10 right-10 w-80 h-80 rounded-full opacity-25 hidden md:block" style={{ background: 'radial-gradient(circle, rgba(30,64,175,0.2) 0%, transparent 70%)' }} />
      <div className="absolute bottom-10 left-10 w-60 h-60 rounded-full opacity-20 hidden md:block" style={{ background: 'radial-gradient(circle, rgba(220,38,38,0.15) 0%, transparent 70%)' }} />
      
      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-white/[0.06] backdrop-blur-md border border-white/[0.08] rounded-full px-4 py-1.5 mb-6">
            <span className="text-blue-300/70 font-semibold text-[11px] uppercase tracking-[0.15em]">
              {VALUE_ITEMS.label}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold text-white leading-tight">
            WHY <span className="text-hevi-red">100+ BUSINESSES</span> ACROSS ONTARIO REFUSE TO USE ANYONE ELSE
          </h2>
        </div>

        {/* Value Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {VALUE_ITEMS.items.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={i}
                className="group relative rounded-2xl p-7 border border-white/[0.07] hover:border-white/[0.15] transition-all duration-500 overflow-hidden"
                style={{ background: 'rgba(255,255,255,0.04)', backdropFilter: 'blur(20px)' }}
              >
                {/* Hover glow */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/[0.03] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                <div className="relative z-10">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-colors duration-300" style={{ background: 'rgba(30,64,175,0.12)' }}>
                    {Icon && <Icon size={22} className="text-blue-400" />}
                  </div>
                  <h3 className="text-[15px] font-bold text-white mb-2.5">
                    {item.title}
                  </h3>
                  <p className="text-white/45 text-[13.5px] leading-relaxed mb-4">
                    {item.description}
                  </p>
                  <div className="inline-flex items-center gap-1.5 text-[11px] font-bold text-blue-400 uppercase tracking-wider">
                    <ArrowRight size={11} />
                    {item.value}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
